import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    goalsList: [],
    categories: [],
    goalsListLoading: false,
    goalsListSuccess: null,
    goalsListError: '',
    getGoalsListLoading: false,
    getGoalsListSuccess: null,
    getGoalsListError: ''
}

export const goalSlice = createSlice({
    name: 'goal',
    initialState,
    reducers: {
        getCategoryList: (state, action) => {
            state.categories = action.payload.map((item) => ({ ...item, value: item.id, label: item.name }))
        },
        setGoalsListLoading: (state) => {
            state.goalsListLoading = true;
            state.goalsListSuccess = null;
            state.goalsListError = '';
        },
        setGoalsListSuccess: (state, action) => {
            state.goalsListLoading = false;
            state.goalsListSuccess = action.payload;
            state.goalsListError = '';
        },
        setGoalsListError: (state, action) => {
            state.goalsListLoading = false;
            state.goalsListSuccess = null;
            state.goalsListError = action.payload;
        },
        setGetGoalsListLoading: (state) => {
            state.getGoalsListLoading = true;
            state.getGoalsListSuccess = null;
            state.getGoalsListError = '';
        },
        setGetGoalsListSuccess: (state, action) => {
            state.getGoalsListLoading = false;
            state.getGoalsListSuccess = action.payload;
            state.getGoalsListError = '';
        },
        setGetGoalsListError: (state, action) => {
            state.getGoalsListLoading = false;
            state.getGoalsListSuccess = null;
            state.getGoalsListError = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { getCategoryList, setGoalsListLoading, setGoalsListSuccess, setGoalsListError, setGetGoalsListLoading, setGetGoalsListSuccess, setGetGoalsListError } = goalSlice.actions

export default goalSlice.reducer;